import { useParams, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { MdArrowBack } from "react-icons/md"
import AgentTraining from "./AgentTraining"
import IndividualReport from "./IndividualReport"
import { FaTimes } from "react-icons/fa"
import { NumberCard } from "../../layouts/ChartLayout"
import { Check, Copy, Download } from "lucide-react"
import server from "../../../api/server"
import { downloadIndividualReportAsExcel, downloadTrainingSessionAsExcel } from "../../../utils/excelUtils"
const IndividualTraining = ({serviceID, clientID}) => {
    const {trainingId} = useParams()
    const [service_id, setService_id] = useState(null)
    const [client_id, setClient_id] = useState(null)
    const [training_id, setTraining_id] = useState(null)
    const [report_id, setReport_id] = useState(null)
    const [showReport, setShowReport] = useState(false)
    const [overallMetrics, setOverallMetrics] = useState([])
    const [loading, setLoading] = useState(false)
    const [trainingData, setTrainingData] = useState(null)
    const [trainingMaterials, setTrainingMaterials] = useState(null)
    const [metadata, setMetadata] = useState(null)
    const [email, setEmail] = useState(null)
    const [copyClicked, setCopyClicked] = useState(false)
    const [savedTrainingState, setSavedTrainingState] = useState(null)
    const [isRefreshing, setIsRefreshing] = useState(false)
    const navigate = useNavigate()
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    useEffect(() => {
        if(serviceID){
            setService_id(serviceID)
        }
        if(clientID){
            setClient_id(clientID)
        }
        if(trainingId){
            setTraining_id(trainingId)
        }
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
        if (user) {
          setEmail(user.email);
        }
    }, [serviceID, clientID, trainingId])

    useEffect(() => {
        if(service_id && client_id && training_id){
            getTrainingData()
        }
    }, [service_id, client_id, training_id])

    const getTrainingData = async () => {
        try {
            // Only show loading if this is not a refresh (initial load)
            if (!isRefreshing) {
                setLoading(true)
            }
            let res = await server.getTrainingDataDetails(client_id, service_id, email, training_id, 'agent-feedback', 'training')
            if(res.status === 200){
                let resp = await res.json()
                // Only update training data if it's significantly different or initial load
                if (!isRefreshing || !trainingData) {
                    setTrainingData(resp.data)
                }
                setTrainingMaterials(resp.training_materials)
                setMetadata(resp.metadata)
                let metrics = [{
                    id: 'totalModules',
                    title: 'Total Modules',
                    value: resp.data?.total_modules,
                    change: undefined,
                    color: '#4F46E5',
                    allowVisit: false,
                    hideBorder: true,
                    formatter: (value) => value
                  },
                    {
                      id: 'completedModules',
                      title: 'Completed Modules',
                      value: resp.data?.completed_modules,
                      change: undefined,
                      color: '#10B981',
                      allowVisit: false,
                      hideBorder: true,
                      formatter: (value) => value
                    },
                    {
                      id: 'totalQuestions',
                      title: 'Total Questions',
                      value: resp.data?.total_questions,
                      change: undefined,
                      color: '#EF4444',
                      allowVisit: false,
                      hideBorder: true,
                      formatter: (value) => value
                    },
                    {
                      id: 'completedQuestions',
                      title: 'Completed Questions',
                      value: resp.data?.completed_questions,
                      change: undefined,
                      color: '#F59E0B',
                      allowVisit: false,
                      hideBorder: true,
                      formatter: (value) => value
                    },
                    {
                      id: 'score',
                      title: 'Score',
                      value: resp.data?.score,
                      change: undefined,
                      color: '#8B5CF6',
                      allowVisit: false,
                      hideBorder: true
                    }]
                setOverallMetrics(metrics)
            }
        } catch (error) {
        } finally {
            // Only clear loading if we set it
            if (!isRefreshing) {
                setLoading(false)
            }
            setIsRefreshing(false)
        }
    }
    const handleGoBack = () => {
        navigate(-1)
    }
    const handleViewReport = (reportId) => {
        setReport_id(reportId)
        setShowReport(true)
    }
    const handleDownload = () => {
        try {
            const filename = `training-session-${metadata?.training_session_id || 'session'}-${new Date().toISOString().split('T')[0]}.xlsx`;
            downloadTrainingSessionAsExcel(filename, trainingData, metadata);
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error generating Excel. Please try again.');
        }
    }
    const create_date_range = (start_time, end_time) => {
        let start_date = new Date(start_time * 1000);
        let end_date = new Date(end_time * 1000);
        return `${start_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} - ${end_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`;
      }
      const handleBackApiCall = (value, trainingState = null) => {
        if(value){
          // Save the training state before refreshing
          if(trainingState) {
            setSavedTrainingState(trainingState)
          }
          setIsRefreshing(true)
          getTrainingData()
        }
      }
    return (
        <div style={{ width: "100%", height: window.innerHeight - 66.5, overflowY: "auto" }} className="bg-gray-50 px-5">
      {
        trainingData && (
          <>
          <div className={`flex justify-between`}>
            <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px', cursor: 'pointer'}}>
              <MdArrowBack style={{ marginRight: '8px' }} />
              Back
            </button>
            <button onClick={handleDownload} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px', cursor: 'pointer'}}>
              <Download style={{ marginRight: '8px' }} size={16}/>
              Download
            </button>
          </div>
          {
            !trainingData ? (
              <>
                <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                    <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                    <h2 style={{textAlign: "center", fontSize: "24px"}}>No Training Found.</h2>
                </div>
              </>
            ) : (
              <div>
                <div className="flex justify-between items-center border p-4 rounded-lg bg-white" style={{gap: "10px", flexWrap: "wrap"}}>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Training Session ID</h2>
                        <p style={{fontSize: "15px", display: "flex", alignItems: "center"}}>{metadata?.training_session_id.length > 20 ? metadata?.training_session_id.slice(0, 20) + '...' : metadata?.training_session_id} 
                            {!copyClicked &&<Copy className='cursor-pointer ml-2 mr-2 text-xs h-4 w-4' onClick={() => {navigator.clipboard.writeText(metadata?.training_session_id); setCopyClicked(true); setTimeout(() => {setCopyClicked(false)}, 1000)}} />}
                            {copyClicked &&<Check className='cursor-pointer ml-2 mr-2 text-xs h-4 w-4' />}
                            </p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Employee ID</h2>
                        <p style={{fontSize: "15px"}}>{metadata?.employee_id}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Status</h2>
                        <p style={{
                            fontSize: "15px", 
                            textTransform: "capitalize",
                            backgroundColor: metadata?.status === 'pending' ? '#fef3cd' : (metadata?.status === 'ongoing') ? '#e0e7ff' : '#dcfce7',
                            color: metadata?.status === 'pending' ? '#92400e' : (metadata?.status === 'ongoing') ? '#4338ca' : '#166534',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            display: 'inline-block'
                        }}>{metadata?.status}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Linked Report</h2>
                        <p style={{transition: "background 0.3s, color 0.3s, box-shadow 0.3s", border: "1px solid rgb(209 213 217)", width: "90px", fontSize: "12px", textAlign: "center", padding: "3px", borderRadius: "6px", cursor: "pointer", background: "white"}} onClick={()=>handleViewReport(metadata?.source_report_id)}>View Details</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Date Range</h2>
                        <p style={{fontSize: "15px"}}>{create_date_range(metadata?.report_start_time, metadata?.report_end_time)}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Created At</h2>
                        <p style={{fontSize: "15px"}}>{new Date(metadata?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Due At</h2>
                        <p style={{fontSize: "15px"}}>{new Date(metadata?.due_at*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: "1rem", padding: "1rem 0", height: "150px", position: "relative"}}>
                    {isRefreshing && (
                        <div style={{
                            position: "absolute",
                            top: "0",
                            right: "10px",
                            background: "rgba(79, 70, 229, 0.1)",
                            color: "#4F46E5",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            zIndex: 10
                        }}>
                            Updating...
                        </div>
                    )}
                    {
                        overallMetrics.map((metric, idx) => {
                            return (
                                <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard key={idx} metric={metric}/></div>
                            )
                        })
                    }
                </div>
                <AgentTraining 
                    trainingData={trainingData} 
                    clientID={client_id} 
                    serviceID={service_id} 
                    emailID={email} 
                    training_session_id={training_id} 
                    prop_back_api_call={handleBackApiCall}
                    savedState={savedTrainingState}
                    isRefreshing={isRefreshing}
                    onStateRestore={() => setSavedTrainingState(null)}
                    training_material={trainingMaterials}
                />
            </div>
            )
        }
        </>
        )}
        {
            showReport && (
                <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                    <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999"}}>
                        <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowReport(false); setReport_id(null);}}><FaTimes style={{color: "slategray"}}/></div>
                        <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
                            <IndividualReport reportIdProp={report_id} clientID={client_id} serviceID={service_id} />
                        </div>
                    </div>
                </div>
            )
        }
    </div>
    )
}

export default IndividualTraining;